import { NgModule } from 'ng-metadata/core';
import { FabComponent } from './fab.component';
import { FabTriggerButtonComponent } from './fab-trigger-button.component';
import { FabActionButtonComponent } from './fab-action-button.component';
import './fab.scss';

/**
 * @ngdoc module
 * @name mw.components.fab
 * @description
 *
 * FABs
 */
@NgModule({
  declarations: [ FabComponent, FabTriggerButtonComponent, FabActionButtonComponent ]
})
export class FabModule {}



// WEBPACK FOOTER //
// ./src/lib/components/fab/fab.module.ts